import { GlobalStyles, useTheme } from '@mui/material'

import { postNavigateToStat } from 'api/stats/stats.api'
import React, { ReactElement, useEffect } from 'react'
import { useLocation } from 'react-router'
import alertStore from 'store/alert/alert'
import zoomStore from 'store/zoom/zoom'
import { useAuth } from 'ui/components/AuthContext/AuthContext'
import sentry from 'utils/sentry/sentry'
import AuthenticatedApp from './components/AuthenticatedApp/AuthenticatedApp'
import UnauthenticatedApp from './components/UnauthenticatedApp/UnauthenticatedApp'

function App(): ReactElement {
  const location = useLocation()
  const { user } = useAuth()

  useEffect(() => {
    postNavigateToStat()

    // clear alerts on location change
    alertStore.alertClear()

    const route = location?.pathname?.split(`/`)?.[1] ?? ``
    zoomStore.route = route

    // Track route visits in Sentry (only for authenticated users)
    if (user) {
      sentry.captureRouteVisit(route)
    }
  }, [location, user])

  return user ? <AuthenticatedApp /> : <UnauthenticatedApp />
}

export default function AppWithStyles(): ReactElement {
  const theme = useTheme()

  const styles = {
    body: {
      fontFamily: theme.typography.fontFamily,
    },
    // Change scrollbar style
    '*::-webkit-scrollbar': {
      borderRadius: `10px`,
      width: `10px`,
      height: `10px`,
    },
    '*::-webkit-scrollbar-track': {
      borderRadius: `10px`,
      backgroundColor: `rgba(0,0,0,.1)`,
      // '-webkit-box-shadow': `inset 0 0 6px rgba(0,0,0,0.3)`,
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: `rgba(0,0,0,.2)`,
      borderRadius: `10px`,
    },
    '*::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(0,0,0,.5)',
    },
  }

  return (
    <>
      <GlobalStyles styles={styles} />
      <App />
    </>
  )
}
